<template>
  <router-view v-if="!$route.meta.keepAlive"></router-view>
</template>

<style lang="scss">
body {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000;
  padding: 0;
  margin: 0;
}
.el-message{
  font-size: 24px;
  font-weight: bold;
  line-height: 40px;
  color: red;
}

</style>
